import { render, staticRenderFns } from "./ApiZugriff.vue?vue&type=template&id=5bcc86f7&scoped=true"
import script from "./ApiZugriff.vue?vue&type=script&lang=js"
export * from "./ApiZugriff.vue?vue&type=script&lang=js"
import style0 from "./ApiZugriff.vue?vue&type=style&index=0&id=5bcc86f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc86f7",
  null
  
)

export default component.exports